import moment from 'moment';
import { convertToPhoneRequestFormat, deleteUnwantedRequest } from '../../../../Utils/CommonBaseClass';

 /**
   * This method compares the GET API BO Data and the AutoSave API BO data 
   * to have a more secure version of the BO list
   * @param autoSavedData 
   * @param beneficialOwnerData 
   * @returns 
   */
  export const mergeBeneficialOwners = (
      autoSavedData: any[] = [],
      beneficialOwnerData: any[] = []
  ) => {
      const baseData = autoSavedData.length > 0 ? autoSavedData : beneficialOwnerData;

      return baseData.map((base, idx) => {
          const overlay = beneficialOwnerData[idx];
          const merged = { ...base };

          if (overlay) {
          // Always replace ID
          merged.id = overlay.id;

          // Merge other non-empty fields from overlay
          Object.keys(overlay).forEach((key) => {
              if (key === 'id') return; // already handled
                  const val = overlay[key];
              if (val !== undefined && val !== '') {
                  merged[key] = val;
              }
              });
          }
          return merged;
      });
  };

/**
 * This method creates an api friendly request from the BO data recieved from the autosave API
 * @param data 
 * @returns 
 */
export const buildOwnerRequest = (data: any) => {
    const req: any = {
      ...data,
      isPrimaryOwner: false,
      portalAccess: {
        grantAccess: true
      }
    };

    //Handling the SSN/ITIN Nodes while request creation
    if (data?.ssn?.length > 10){
        req['ssn'] = data.ssn;
        delete req['itin'];
    } else if (data?.itin?.length > 10){
        req['taxIdentification'] = {
            type: "ITIN",
            id: data.itin
        };
        delete req['ssn'];

    } else{
          delete req['ssn'];
          delete req['itin'];
    }
  
    // Validate and format mobile phone
    if (!data.mobilePhone) {
      return { error: 'mobilePhone is required', field: 'mobilePhone' };
    }
    req.mobilePhone = convertToPhoneRequestFormat(data.mobilePhone);
    if (req.mobilePhone === '') {
      delete req.mobilePhone;
    }
  
    // Format date of birth
    if (data.dob) {
      req.dob = moment(data.dob).format('MM/DD/YYYY');
    }
  
    // Build mailing address
    req.mailingAddress = [{
      addressLine1: data.addressLine1,
      addressLine2: data.addressLine2,
      city: data.city,
      state: data.state,
      zip: data.zip,
      isPrimary: true
    }];
  
    // // Remove fields not needed in final request
    const unwantedRequestArray = [
      'state', 'addressLine1', 'city', 'zip', 'addressLine2', 'mobilePhone-select'
    ];
  
    deleteUnwantedRequest(req, unwantedRequestArray);
  
    return {data, req};
  };

  /**
   * Method for creating the Joint tenancy request
   * @param data 
   * @returns 
   */
  export function signUpJointTenancy(data: any) {
      const details: any = data.details ? data.details : {};
      const address: any = {
          addressLine1: details['addressLine1'],
          addressLine2: details['addressLine2'] ? details['addressLine2'] : '',
          city: details['city'],
          state: details['state'],
          zip: details['zip'],
          isPrimary: true
      };
      if(details.addressLine2 === undefined || details.addressLine2 === ''){
          delete address['addressLine2']
      }
      if(details['address_id']){
          address['id'] = details['address_id'];
      }

      const primaryOwners:any =  {
          "id": details.id,
          "isPrimaryOwner":true,
          "portalAccess": { "grantAccess": true },
          "firstName": details.firstName,
          "middleName": details.middleName,
          "lastName": details.lastName,             
          "dob": moment(details.dob).format('MM/DD/YYYY'),
          "email": details.email,
          "mobilePhone": convertToPhoneRequestFormat(details.mobilePhone),
          "mailingAddress": [address]
      };
      if (details?.ssn?.length > 10){
          primaryOwners['ssn'] = details.ssn;
      } else if (details?.itin?.length > 10){
          primaryOwners['taxIdentification'] = {
              type: "ITIN",
              id: details.itin
          };
      }  

      const req:any = {
          customer: {
              "type": "JOINT_TENANCY",
              "owners": [primaryOwners],
          }
      }

      if(details.middleName === undefined || details.middleName === ''){
          delete req['customer']['owners'][0]['middleName']
      }
      
      return req;
  }